export default __webpack_public_path__ + "static/media/call-2.f4204a26.svg";